import Cookies from 'universal-cookie';
import queryString from 'query-string';
import About from './containers/About';
import Contact from './containers/Contact';
import Educators from './containers/Educators';
import FAQ from './containers/FAQ';
import GirlScouts from './containers/GirlScouts';
import Home from './containers/Home';
import Homeschool from './containers/Homeschool';
import HourOfCode from './containers/HourOfCode';
import HowItWorks from './containers/HowItWorks';
import MinervaLookup from './containers/MinervaLookup';
import NotFoundPage from './containers/404';
import Press from './containers/Press';
import Privacy from './containers/Privacy';
import PrivacyRequestForm from './containers/PrivacyRequestForm';
// import ProfessionalDevelopment from './containers/ProfessionalDevelopment';
import Terms from './containers/Terms';
import Credits from './containers/Credits';
import { getJSONOffers } from './services/parse';
import { COOKIE_KEY_PLAN_TAG, COOKIE_KEY_SELECTED_OFFER_ID } from './constants/cookies';
import isServer from './utils/isServer';
import { getCrossDomainOptions } from './utils/cookieUtils';

// Wrap routes inside closure with expressRequest so that we can extract and set cookies since
// Curi does not expose cookies to the routes
const getRoutes = expressRequest => {
  const cookie = isServer() ? expressRequest.headers.cookie : undefined;
  const cookies = new Cookies(cookie);
  const queryParams = isServer() ? expressRequest.query : queryString.parse(window.location.search);
  const { activePlanTag, selected_plan: selectedOfferId } = queryParams;

  const saveQueryToCookies = queryArray => {
    const cookieOptions = getCrossDomainOptions({}, expressRequest);

    queryArray.forEach(([key, value]) => {
      if (value) {
        cookies.set(key, value, cookieOptions);
      }
    });
  };

  const loadPlans = () => {
    const params = {
      tag: activePlanTag || cookies.get(COOKIE_KEY_PLAN_TAG) || null,
    };
    return getJSONOffers(params);
  };

  const generatePlansData = resolved => {
    if (resolved && resolved.error) {
      console.error('There was an error fetching the offers: ', resolved.error);
    }
    const queriesToSaveToCookies = [
      [COOKIE_KEY_PLAN_TAG, activePlanTag],
      [COOKIE_KEY_SELECTED_OFFER_ID, selectedOfferId],
    ];

    saveQueryToCookies(queriesToSaveToCookies);
    return {
      planOptions: resolved && resolved.every ? resolved.every : [],
      // Set initial selectedOfferId and planTag to value from query params or cookies
      selectedOfferId: selectedOfferId || cookies.get(COOKIE_KEY_SELECTED_OFFER_ID),
      planTag: activePlanTag || cookies.get(COOKIE_KEY_PLAN_TAG),
    };
  }; 

  const routes = [
    {
      name: 'Home',
      path: '',
      response: ({ resolved }) => ({
        body: Home,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'Educators',
      path: 'educators',
      response: ({ resolved }) => ({
        body: Educators,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'HourOfCode',
      path: 'hour-of-code',
      response: ({ resolved }) => ({
        body: HourOfCode,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'FAQ',
      path: 'frequently-asked-questions',
      response: ({ resolved }) => ({
        body: FAQ,
        data: generatePlansData(resolved),
      }),
    },
  
    {
      name: 'HowItWorks',
      path: 'how-it-works',
      response: ({ resolved }) => ({
        body: HowItWorks,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'About',
      path: 'about',
      response: ({ resolved }) => ({
        body: About,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'Homeschool',
      path: 'homeschool',
      response: ({ resolved }) => ({
        body: Homeschool,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'Contact',
      path: 'contact',
      response: ({ resolved }) => ({
        body: Contact,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'Press',
      path: 'press',
      response: ({ resolved }) => ({
        body: Press,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'Privacy',
      path: 'privacy',
      response: ({ resolved }) => ({
        body: Privacy,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'PrivacyRequestForm',
      path: 'privacy-request-form',
      response: ({ resolved }) => ({
        data: {
          ...generatePlansData(resolved),
          isLanding: true,
        },
        body: PrivacyRequestForm,
      }),
    },
    {
      name: 'Terms',
      path: 'terms',
      response: ({ resolved }) => ({
        body: Terms,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'GirlScouts',
      path: 'girl-scouts',
      response: ({ resolved }) => ({
        body: GirlScouts,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'MinervaLookup',
      path: 'promo-help',
      response: ({ resolved }) => ({
        body: MinervaLookup,
        data: generatePlansData(resolved),
      }),
    },
    {
      name: 'Credits',
      path: 'credits',
      response: () => ({
        body: Credits,
      }),
    },
    {
      name: 'NotFound',
      path: '(.*)',
      response: ({ resolved }) => ({
        status: 404,
        body: NotFoundPage,
        data: generatePlansData(resolved),
      }),
    },
  ];

  const attachLoadPlans = route => {
    const routeWithPlanLoad = {
      ...route,
    };

    if (!routeWithPlanLoad.on) {
      routeWithPlanLoad.on = {
        every: loadPlans,
      };
    }

    if (!routeWithPlanLoad.on.every) {
      routeWithPlanLoad.on = {
        ...routeWithPlanLoad.on,
        every: loadPlans,
      };
    }

    return routeWithPlanLoad;
  };
  return routes.map(attachLoadPlans);
}

export default getRoutes;



// WEBPACK FOOTER //
// ./src/routes.js